import { useState, useCallback, useEffect } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import axios from "axios";
import useCookie from "../hooks/useCookie";
import useCurrentUser from "../hooks/useCurrentUser";
import Topbar from "../components/Topbar";
import GoBackLink from "../components/GoBackLink";
import "../css/AlgoArtPage.css";
import rotationIcon from "../images/rotation-icon.png";

const unityBuild = "algorithmic-art-build/Build/algorithmic-art-build";

function AlgoArt() {
  let user = null;
  user = useCurrentUser();

  const csrftoken = useCookie("csrftoken");
  const headers = {
      "X-CSRFToken": csrftoken,
  };

  // Gallery IDs - used to save image to profile
  const [recentGallery, setRecentGallery] = useState(-1); // "Recent" gallery ID
  const [savedGallery, setSavedGallery] = useState(-1); // "Saved" gallery ID
  const [landscapeMode, setLandscapeMode] = useState(false);

  // Get recent and saved IDs once we have user
  useEffect(() => {
      getIDs();
      setLandscapeMode(isLandscapeMode());
  }, [user]);

  // Get recent and saved gallery IDs for this user
  const getIDs = () => {
      if (user) {
          // Grab gallery IDs
          if (user.is_staff) {
              if (user.is_superuser) { // User is Admin
                  axios.get("/api/admins/" + user.id)
                    .then((response) => {
                        let teacher = response.data;
                        setRecentGallery(teacher.recent);
                        setSavedGallery(teacher.saved);              
                    });
              } else { // User is Teacher
                  axios.get("/api/teachers/" + user.id)
                  .then((response) => {
                      let teacher = response.data;
                      setRecentGallery(teacher.recent);
                      setSavedGallery(teacher.saved);              
                  });
              }
          } else { // User is Student
              axios.get("/api/students/" + user.id)
              .then((response) => {
                  let student = response.data;
                  setRecentGallery(student.recent);
                  setSavedGallery(student.saved);
              });
          }
      }
  };

    // Detect if screen is in landscape when window is resized
    window.onresize = function(){
        setLandscapeMode(isLandscapeMode());
    }
    
    // Allow 9/10 ratio before prompting user to change orientation of screen
    const isLandscapeMode = () => {
        return window.innerWidth >= ((9/10) * window.innerHeight);
    }

    // useEffect(() => {
    //     if (landscapeMode) {
    //         let gameCanvas = document.getElementsByTagName("canvas")[0];
    //         if (gameCanvas) {
    //             gameCanvas.focus();
    //         }
    //     }        
    // }, [landscapeMode]);

  // Save image to recent and saved galleries
  const saveImage = (base64Image) => {
    if (recentGallery != -1 && savedGallery != -1) {
        let imgObj = {
            "prompt": "Algorithmic art image",
            "picture": base64Image,
            "studio": "ALG_ART"
        };

        // Post to recent gallery
        imgObj["gallery"] = recentGallery;
        axios.post("/api/images/", imgObj, { headers })
        .then((response) => {
            // Post to saved gallery
            imgObj["gallery"] = savedGallery;
            axios.post("/api/images/", imgObj, { headers })
            .then((response) => {
                sendMessage("Algorithmic Art Manager", "ConfirmSave", "FractalImageSave Success");
            }).catch((error) => {
                sendMessage("Algorithmic Art Manager", "ConfirmSave", "FractalImageSave Error: " + error);
            });
        }).catch((error) => {
            sendMessage("Algorithmic Art Manager", "ConfirmSave", "FractalImageSave Error: " + error);
        });
    }
  };

  useEffect(() => {
    addEventListener("SendImage", saveImage);  

    return function() {
        removeEventListener("SendImage", saveImage);
    }
  })

  // Set up the state of the Unity application by specifying the location of the build files.
  // See: https://react-unity-webgl.dev/docs/main-concepts/unity-config
  const { unityProvider, sendMessage, addEventListener, removeEventListener } = useUnityContext({
      loaderUrl: `${unityBuild}.loader.js`,
      dataUrl: `${unityBuild}.data`,
      frameworkUrl: `${unityBuild}.framework.js`,
      codeUrl: `${unityBuild}.wasm`,
  });


  return (
    <div className = "page-with-splash">     
      <Topbar isExplorePage = {true}/> {/* Algorithmic Art is a "child" of Explore page */}
      <GoBackLink pageName = "Explore" pageLink = "/explore" />
        <div id="game" style={{ flexGrow: "1", height: "100%", width: "100%" }}>
            {!landscapeMode ? (
                <div id="profile-mode-overlay"> {/* Ensure that user is using tool in landscape */}
                    <p>Device must be in landscape mode to use this studio.</p>
                    <img src={rotationIcon}/>
                </div>
            ) : (null)}
            <Unity unityProvider={unityProvider} />
        </div>        
    </div>
  )
}

export default AlgoArt;
